import React from 'react';
import { cn } from '../../lib/utils';
import Icon from './Icon';

export default function Pagination({ page, totalPages, onPageChange }) {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const visiblePages = pages.filter(
    (p) => p === 1 || p === totalPages || Math.abs(p - page) <= 1
  );

  let prevPage = null;
  const rendered = [];
  visiblePages.forEach((p) => {
    if (prevPage !== null && p - prevPage > 1) {
      rendered.push('...');
    }
    rendered.push(p);
    prevPage = p;
  });

  return (
    <div className="glass mt-6 inline-flex items-center gap-1 rounded-full p-1.5">
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        className="grid h-9 w-9 place-items-center rounded-full text-slate-600 transition hover:bg-ink hover:text-white disabled:opacity-40 disabled:pointer-events-none"
      >
        <Icon name="chevronLeft" className="h-4 w-4" />
      </button>

      {rendered.map((item, idx) =>
        typeof item === 'number' ? (
          <button
            key={idx}
            onClick={() => onPageChange(item)}
            className={cn(
              'h-9 min-w-9 px-3 rounded-full text-sm font-bold transition-all',
              item === page
                ? 'bg-ink text-floodlight shadow-lg shadow-ink/25'
                : 'hover:bg-white text-slate-600'
            )}
          >
            {item}
          </button>
        ) : (
          <span key={idx} className="px-2 text-slate-400">
            …
          </span>
        )
      )}

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
        className="grid h-9 w-9 place-items-center rounded-full text-slate-600 transition hover:bg-ink hover:text-white disabled:opacity-40 disabled:pointer-events-none"
      >
        <Icon name="chevronRight" className="h-4 w-4" />
      </button>
    </div>
  );
}